export default __webpack_public_path__ + "static/media/folder.ec7ce0e4.svg";